import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "editBtn",
    "dashboard",
    "removeBtn",
    "nonFavDashboard",
    "nonFavSaveBtn",
    "saveBtn",
  ];

  toggle() {
    this.editBtnTarget.classList.toggle("bg-primary");
    this.editBtnTarget.classList.toggle("text-white");

    this.saveBtnTarget.classList.toggle("hidden");

    this.removeBtnTargets.forEach((btn) => {
      btn.classList.toggle("hidden");
    });

    this.dashboardTargets.forEach((dashboard) => {
      Array.from(dashboard.getElementsByClassName("card")).forEach(
        (card) => {
          card.classList.toggle("hidden");
        }
      );
    });
  }

  checkNonFavDashboard(event) {
    const borderClasses = [
      "border-solid",
      "border-2",
      "border-tealLight",
      "checked",
    ];
    const uid = event.params.uid;

    // toggle selected dashboards classes
    const nonFavDashboard = this.nonFavDashboardTargets.find(
      (target) => target.dataset.uid == uid
    );
    borderClasses.forEach((borderClass) =>
      nonFavDashboard.classList.toggle(borderClass)
    );

    // if selected, & button hidden, unhide
    const checkedCheckboxes = Array.from(
      event.target.parentElement.parentElement.getElementsByTagName("input")
    ).filter((input) => input.type === "checkbox" && input.checked);

    if (checkedCheckboxes.length > 0) {
      this.nonFavSaveBtnTarget.disabled = false;
    } else {
      this.nonFavSaveBtnTarget.disabled = true;
    }
  }

  checkDashboard(event) {
    const removedClasses = [
      "opacity-50",
    ];
    const uid = event.params.uid;
    const dashboard = this.dashboardTargets.find(
      (target) => target.dataset.uid == uid
    );

    // toggle selected dashboards classes
    removedClasses.forEach((removedClass) =>
      dashboard.classList.toggle(removedClass)
    );

    // toggle shown heroicon
    dashboard.getElementsByTagName("svg")[0].classList.toggle("hidden");
    dashboard.getElementsByTagName("svg")[1].classList.toggle("hidden");

    // if selected, & button hidden, unhide
    const checkedCheckboxes = Array.from(
      event.target.parentElement.parentElement.getElementsByTagName("input")
    ).filter((input) => input.type === "checkbox" && input.checked);

    if (checkedCheckboxes.length > 0) {
      this.saveBtnTarget.disabled = false;
    } else {
      this.saveBtnTarget.disabled = true;
    }
  }

  async addDashboards() {
    const selectedDashboards = this.nonFavDashboardTargets
      .filter((nonFavDashboard) => nonFavDashboard.children[0].checked)
      .map((nonFavDashboard) => nonFavDashboard.children[0].value);

    try {
      const response = await fetch("/users/set_favorite_dashboards", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "text/vnd.turbo-stream.html, text/html, application/json",
        },
        body: JSON.stringify({
          fav_uids: selectedDashboards.map((uid) => {
            return { uid: uid, favorite: true };
          }),
        }),
      });

      if (response.ok) {
        Turbo.visit(window.location.pathname, { action: "replace" });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async removeDashboards() {
    const selectedDashboards = this.dashboardTargets
      .filter((dashboard) => dashboard.children[0].checked)
      .map((dashboard) => dashboard.children[0].value);
    if (selectedDashboards.length > 0) {
      try {
        const response = await fetch("/users/set_favorite_dashboards", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
              .content,
            Accept: "text/vnd.turbo-stream.html, text/html, application/json",
          },
          body: JSON.stringify({
            fav_uids: selectedDashboards.map((uid) => {
              return { uid: uid, favorite: false };
            }),
          }),
        });

        if (response.ok) {
          Turbo.visit(window.location.pathname, { action: "replace" });
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  }
}
